import React, {Fragment} from "react";
import {Card, CardBody, CardTitle, Col, Row} from "reactstrap";
import {FaChartLine, FaChartPie, FaHeart, FaSimCard} from "react-icons/fa";
import {DashboardTable} from "./dashboardTable";
import {useDashboardData} from "./useDashboardData";
import "../commonView.scss";

const DashboardPage = () => {
  const {dashboardData = {}} = useDashboardData();
  const {
    cellular_usage,
    system_alerts = {},
    system_health = {},
    total_controllers,
  } = dashboardData;

  return (
    <Fragment>
      <Row style={{marginTop: "20px"}}>
        <Col lg="6" xl="3">
          <Card className="card-stats mb-4 mb-xl-0">
            <CardBody className="whitecard">
              <Row>
                <div className="col">
                  <CardTitle tag="h5" className="text-uppercase mb-0">
                    Total Controllers
                  </CardTitle>
                  <span className="h2 font-weight-bold mb-0">{total_controllers}</span>
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                    <FaChartLine />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" xl="3">
          <Card className="card-stats mb-4 mb-xl-0">
            <CardBody className="whitecard">
              <Row>
                <div className="col">
                  <CardTitle tag="h5" className="text-uppercase mb-0">
                    Alerts
                  </CardTitle>
                  <span className="h2 font-weight-bold mb-0">
                    {system_alerts.name || "No Alerts"}
                  </span>
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                    <FaChartPie />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" xl="3">
          <Card className="card-stats mb-4 mb-xl-0">
            <CardBody className="whitecard">
              <Row>
                <div className="col">
                  <CardTitle tag="h5" className="text-uppercase  mb-0">
                    LTE Data Usage
                  </CardTitle>
                  <span className="h2 font-weight-bold mb-0">{cellular_usage}</span>
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                    <FaSimCard />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" xl="3">
          <Card className="card-stats">
            <CardBody className="whitecard">
              <Row>
                <div className="col">
                  <CardTitle tag="h5" className="text-uppercase mb-0">
                    System Health
                  </CardTitle>
                  <span className="h2 font-weight-bold mb-0">
                    {system_health.name || "No issues"}
                  </span>
                  <span className="h2 font-weight-bold mb-0">
                    {system_health.state || ""}
                  </span>
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-gradient-blue text-white rounded-circle shadow">
                    <FaHeart />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <DashboardTable />
    </Fragment>
  );
};

export default DashboardPage;
